export const state = () => ({
  message: '',
  icon: '',
  color: '',
})

export const mutations = {
  set (state, data) {
    state.message = data.message
    state.icon = data.icon || require('~/assets/icons/toast-check.svg')
    state.color = data.color || 'bg-[#056DFF]'
  },
}

export const actions = {
  show ({ commit }, data) {
    if (typeof data === 'string') {
      commit('set', { message: data })
    } else {
      commit('set', data)
    }

    setTimeout(() => commit('set', { message: '' }), 3000)
  },

  error ({ dispatch }, message) {
    dispatch('show', {
      message,
      color: 'bg-[#BE3A34]',
      icon: require('~/assets/icons/alert-triangle.svg'),
    })
  },
}
